import { render, staticRenderFns } from "./HospitalList.vue?vue&type=template&id=23f13b6b"
import script from "./HospitalList.vue?vue&type=script&lang=js"
export * from "./HospitalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports